import React, { useState, useEffect } from 'react';
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import RadialSeparators from './RadialSeparators/RadialSeparators';
import './CircleChart.scss';

interface CircleChartProps {
  score: number;
  label?: string;
}

const CircleChart: React.FC<CircleChartProps> = ({ score = 20, label }) => {
  const [animatedScore, setAnimatedScore] = useState(0);

  useEffect(() => {
    let start = 0;
    const duration = 1000;
    const increment = score / (duration / 10);

    const animate = () => {
      if (start < score) {
        start += increment;
        setAnimatedScore(Math.min(start, score));
        requestAnimationFrame(animate);
      } else {
        setAnimatedScore(score);
      }
    };

    animate();
  }, [score]);

  return (
    <CircularProgressbarWithChildren
      value={animatedScore}
      strokeWidth={35}
      styles={buildStyles({
        strokeLinecap: 'butt',
        pathColor: 'transparent',
        trailColor: 'transparent',
      })}>
      <div className="circleChartContent flex flex-col justify-center items-center">
        <span className="value">{Math.round(animatedScore)}%</span>
        {label && <span className="label">{label}</span>}
      </div>
      <RadialSeparators
        count={60}
        value={animatedScore}
        style={{
          background: 'red',
          width: '4px',
          height: `${15}%`,
          borderRadius: '8px',
        }}
        greyStyle={{
          background: 'var(--surface-active)',
          width: '4px',
          height: `${15}%`,
          borderRadius: '8px',
        }}
      />
    </CircularProgressbarWithChildren>
  );
};

export default CircleChart;
